import { useBooking, useResourceBooking } from '@/web-api/bookings';

export const useOriginalBookingDuration = (bookingId: string) => {
  const bookingQuery = useBooking(bookingId);

  const originalDuration =
    bookingQuery.data?.onsite?.duration ||
    bookingQuery.data?.remote?.duration ||
    bookingQuery.data?.phone?.duration ||
    null;

  return { originalDuration, bookingQuery };
};

export const useOriginalResourceBookingDuration = (bookingId: string) => {
  const bookingQuery = useResourceBooking(bookingId);

  const originalDuration =
    bookingQuery.data?.onsite?.duration ||
    bookingQuery.data?.remote?.duration ||
    bookingQuery.data?.phone?.duration ||
    null;

  return { originalDuration, bookingQuery };
};
